import { EntityAdapter } from 'vue-entity-adapter'

export const adapter = new EntityAdapter((a, b) => b.payment_at.localeCompare(a.payment_at))

export default adapter
